import HighEnd from "../../../../src/events/2022/08/high-end/main";
import * as React from 'react';
export default {
  HighEnd,
  React
};